/**
 * WordPress dependencies
 */
import { useEffect } from '@wordpress/element';
import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
/**
 * Internal Dependencies
 */
import './editor.scss';
import InsSettings from './settings.js';
import noimage from "../../../../inc/assets/img/no-image.png";
import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import { VayuBlocksUniqueId } from "@vayu-blocks/global";

export default function Edit(props) {
    const {
        attributes,
        setAttributes,
        clientId,
        context
    } = props;

    // Log all context values to debug
    //console.log('Context values:', context);

    const { id } = attributes;
    const deviceView = VayuBlocksDevice();

    VayuBlocksUniqueId({ 
        setAttributes: setAttributes, 
        clientId: clientId
    });

    const isDesktop = deviceView === 'Desktop';
    const isTablet = deviceView === 'Tablet';
    const isMobile = deviceView === 'Mobile';

    // Use context values with fallbacks
    const slidewidth = {};

    const innerBlocksProps = useInnerBlocksProps(
        {
            style: slidewidth,
        },
        {
            allowedBlocks: ['vayu-blocks/advance-container'],
            directInsert: true,
            orientation: 'horizontal',
            template: [
                [
                    'vayu-blocks/advance-container',
                    { AlignItem: 'start' },
                    [
                        ['vayu-blocks/advance-heading', {
                            content: 'Title...',
                            fontSize: 18,
                            fontSizeUnit: 'px'
                        }],
                        ['vayu-blocks/image', { image: noimage }],
                        ['vayu-blocks/advance-heading', {
                            content: 'Desc...',
                            fontSize: 16,
                            fontSizeUnit: 'px'
                        }],
                        ['vayu-blocks/advance-button', {}],
                    ],
                ]
            ],
            renderAppender: false,
        }
    );

    const blockProps = useBlockProps();

    return (
        <>         
            {/* <InsSettings {...props} /> */}
            <div {...blockProps}>
                <div {...innerBlocksProps} />
            </div>
        </>
    );
}